import { policies } from '@/core/agreements';
import { CLIENT_CONTENT_TREATMENT } from '@/core/contentTreatment';
import { formatCreditsText } from '@/utils';

import Link from '../Link';
import s from './LegalNotes.module.scss';

interface LegalNotesProps {
  bookingFee?: number;
  buttonText?: string; // Customizable button text (default: "Submit Request")
  // The content treatment describes recordings and transcripts, so it only
  // applies to call-type bookings. Written engagements produce no call and are
  // out of scope for Rev 2.1 day 1 (ENG-5566); pass false there.
  showContentTreatment?: boolean;
}

function LegalNotes({
  bookingFee,
  buttonText = 'Submit Request',
  showContentTreatment = true,
}: LegalNotesProps): JSX.Element {
  const tosPol = policies['terms-of-service'];
  const privacyPol = policies.privacy;
  const customerChargePol = policies['customer-charging-policy'];

  return (
    <>
      {showContentTreatment && (
        <div className={s.treatment}>
          <strong>Content treatment:</strong> {CLIENT_CONTENT_TREATMENT}
        </div>
      )}
      <div className={s.root}>
        <span>
          By clicking &ldquo;{buttonText}&rdquo;, you agree that this consultation, including any
          personal data, may be recorded and transcribed by OnFrontiers and used and maintained
          pursuant to OnFrontiers&apos;{' '}
        </span>
        <Link newTab href={tosPol.url}>
          {tosPol.name}
        </Link>{' '}
        <span>and </span>
        <Link newTab href={privacyPol.url}>
          {privacyPol.name}
        </Link>
        <span>, that this consultation is subject to the </span>
        <Link newTab href={customerChargePol.url}>
          {customerChargePol.name}
        </Link>
        {showContentTreatment ? (
          <span>
            , and that the resulting content is handled per the content treatment stated above.{' '}
          </span>
        ) : (
          <span>. </span>
        )}
        {bookingFee ? (
          <span>
            Estimated charges below reflect a {formatCreditsText(bookingFee)} booking fee.
          </span>
        ) : undefined}
      </div>
    </>
  );
}

export default LegalNotes;
